// extracted by mini-css-extract-plugin
module.exports = {"content":"__content__YNspf","testimonialReview":"__testimonialReview__g3bqE","iframe":"__iframe__VI0f3","accordion":"__accordion__JVFgR","icon":"__icon__Rbhy_"};